import {
  callAPI,
  CUSTOMER_DETAILS_ENDPOINT,
  CUSTOMER_TAX_DETAILS_ENDPOINT,
  INVOICES_ENDPOINT,
  UPDATE_SUBSCRIPTION_METADATA_ENDPOINT,
} from "../../app/api/callAPI";
import { PAYMENT_JOB_POST_SERVICE } from "../../features/payments/paymentConstants";

export async function fetchStripeCustomerDetails({
  email,
  stripeCustomerId,
  subscriptionId,
}) {
  return callAPI({
    endpoint: CUSTOMER_DETAILS_ENDPOINT,
    opts: {
      body: {
        email,
        stripeCustomerId,
        subscriptionId,
      },
    },
  });
}

export async function fetchStripeCustomerTaxDetails({
  email,
  stripeCustomerId,
}) {
  return callAPI({
    endpoint: CUSTOMER_TAX_DETAILS_ENDPOINT,
    opts: {
      body: {
        email,
        stripeCustomerId,
      },
    },
  });
}

export async function fetchStripeCustomerInvoices({
  email,
  stripeCustomerId,
  status = "open",
  count = true,
}) {
  return callAPI({
    endpoint: INVOICES_ENDPOINT,
    opts: {
      body: {
        email,
        stripeCustomerId,
        status,
        count,
      },
    },
  });
}

export async function updateSubscriptionJobsPerCycle({
  email,
  subscriptionId,
}) {
  return callAPI({
    endpoint: UPDATE_SUBSCRIPTION_METADATA_ENDPOINT,
    opts: {
      body: {
        email: email,
        subscriptionId: subscriptionId,
        service: PAYMENT_JOB_POST_SERVICE,
      },
    },
  });
}
